export default {
  default: () => import("/vercel/path0/layouts/default.vue"),
  settings: () => import("/vercel/path0/layouts/settings.vue")
}